import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import Spinner from '../../components/Spinner'
import {
  getFavorites,
  getWatchlist,
  getWatchHistory,
} from '../../actions/contentActions'
import googleAnalytics4 from '../../lib/googleAnalytics.js'
import CollectionsSet from '../../components/CollectionsSet'

export class MyListScreen extends React.PureComponent {
  constructor(props) {
    super(props)

    this.state = {
      spinnerVisible: true,
      collections: [],
    }

    this.carouselListRef = React.createRef()
  }

  componentDidMount() {
    if (this.props.favorites === null) {
      getFavorites(this.props.UID)
    }

    if (this.props.watchlist === null) {
      getWatchlist(this.props.UID)
    }

    getWatchHistory(this.props.UID)
    this.refreshCarouselData()

    googleAnalytics4.sendPageViewEvent('My List')
    // GOOGLE ANALYTICS
    /* window.ga('set', 'dimension1', this.props.callSign)
    window.ga('set', 'dimension2', this.props.UID)
    window.ga('set', 'dimension3', this.props.deviceModel)
    window.ga('send', 'pageview', 'My List') */
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.watchlist !== this.props.watchlist ||
      prevProps.favorites !== this.props.favorites ||
      prevProps.watchHistory !== this.props.watchHistory
    ) {
      this.refreshCarouselData()
    }
  }

  refreshCarouselData() {
    if (
      this.props.favorites !== null &&
      this.props.watchlist !== null &&
      this.props.watchHistory !== null
    ) {
      let favorites = {
        collection_type: 'inline',
        slug: 'favorite-shows',
        title: 'Shows',
        item_type: 'show',
        url: this.props.favoritesUrl,
      }
      let watchlist = {
        collection_type: 'inline',
        slug: 'watchlist',
        title: 'Video',
        item_type: 'video',
        url: this.props.watchlistUrl,
      }
      let watchHistory = {
        collection_type: 'inline',
        slug: 'viewing-history',
        title: 'Viewing History',
        item_type: 'video',
        url: this.props.watchHistoryUrl,
      }
      if (
        Array.isArray(this.props.favorites) &&
        this.props.favorites.length === 0
      ) {
        favorites.content = [
          {
            title:
              'You haven\'t added any shows to your List. \n  Save the shows you like by using the "Add to My List"\
            button.',
            video_type: 'empty_set',
            empty_set: true,
            feed_cid: 'favorites_empty_set_no_content',
          },
        ]
      } else if (this.props.favorites === 'error') {
        favorites.content = [
          {
            title:
              "We weren't able to load your shows. Please try again later.",
            video_type: 'empty_set',
            empty_set: true,
            feed_cid: 'favorites_empty_set_error',
          },
        ]
      } else {
        favorites.content = this.props.favorites
      }
      if (
        Array.isArray(this.props.watchlist) &&
        this.props.watchlist.length === 0
      ) {
        watchlist.content = [
          {
            title: `You haven't added any videos to your List. \n  Save the videos you'd like to watch by using the "Add to My List" button`,
            video_type: 'empty_set',
            empty_set: true,
          },
        ]
      } else if (this.props.watchlist === 'error') {
        watchlist.content = [
          {
            title:
              "We weren't able to load your videos. Please try again later.",
            video_type: 'empty_set',
            empty_set: true,
            feed_cid: 'watchlist_empty_set_error',
          },
        ]
      } else {
        let content = this.props.watchlist
        let slicedContent = content.length > 12 ? content.slice(0, 12) : content // watchlist can have more than 12 items in redux
        watchlist.content = slicedContent
      }

      if (
        Array.isArray(this.props.watchHistory) &&
        this.props.watchHistory.length === 0
      ) {
        watchHistory.content = [
          {
            title:
              "You haven't watched any videos since signing in. \n  We'll keep track of every video you watch and list them here.",
            video_type: 'empty_set',
            empty_set: true,
            feed_cid: 'watchHistory_empty_set_no_content',
          },
        ]
      } else if (this.props.watchHistory === 'error') {
        watchHistory.content = [
          {
            title:
              "We weren't able to load your viewing history. Please try again later.",
            video_type: 'empty_set',
            empty_set: true,
            feed_cid: 'watchHistory_empty_set_error',
          },
        ]
      } else {
        watchHistory.content = this.props.watchHistory
      }

      this.setState({
        collections: [favorites, watchlist, watchHistory],
        spinnerVisible: false,
      })
    }
  }

  render() {
    const { spinnerVisible, collections } = this.state
    return (
      <>
        {spinnerVisible && <Spinner />}
        {'undefined' !== typeof collections && !spinnerVisible && (
          <CollectionsSet collections={collections} />
        )}
      </>
    )
  }
}

MyListScreen.propTypes = {
  callSign: PropTypes.string,
  deviceModel: PropTypes.string,
  favoritesUrl: PropTypes.string,
  watchlistUrl: PropTypes.string,
  watchHistoryUrl: PropTypes.string,
  dispatch: PropTypes.func,
  favorites: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
  watchlist: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
  watchHistory: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
  UID: PropTypes.string,
}

const mapStateToProps = (state) => {
  return {
    UID: state.device.UID,
    callSign: state.station['call_sign'],
    deviceModel: state.device.deviceModel,
    favorites: state.personalization.favorites,
    favoritesUrl: state.personalization.favoritesUrl,
    watchlist: state.personalization.watchlist,
    watchlistUrl: state.personalization.watchlistUrl,
    watchHistory: state.personalization.watchHistory,
    watchHistoryUrl: state.personalization.watchHistoryUrl,
  }
}

export default connect(mapStateToProps, null, null)(MyListScreen)
